import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const uspSlides = [
  {
    src: "/assets/images/fasteners/usp-step1.png",
    caption:
      "An M20x90 Hex Bolt in grade 8.8 before and after Zinc White Plating",
  },
  {
    src: "/assets/images/fasteners/usp-step2.png",
    caption:
      "We use wooden boxes as tertiary packaging for long haul shipments",
  },
  {
    src: "/assets/images/fasteners/usp-step3.png",
    caption:
      "Plastic film is applied as secondary packaging to make product moisture proof",
  },
  {
    src: "/assets/images/fasteners/usp-step4.png",
    caption:
      "Fasteners are packed according to station requirement in separate bags",
  },
  {
    src: "/assets/images/fasteners/usp-step5.png",
    caption:
      "Wooden Box is sealed with metal straps and marked with identification numbers",
  },
];

const Fasteners = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000, //lower the speed, faster the slides will move
  };

  return (
    <section className="bg-gray-100 py-16 text-gray-800">
      <div className="max-w-6xl mx-auto px-4 space-y-12">
        {/* Page Title */}
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-2">Fasteners</h1>
          <p className="text-gray-600 text-lg">
            Reliable, corrosion-resistant, and custom-packaged fastening
            solutions.
          </p>
        </div>

        {/* Description */}
        <div className="bg-white p-6 rounded shadow text-lg space-y-4">
          <p>
            At <strong>Avon Tools</strong>, we offer a comprehensive range of
            industrial fasteners designed for strength, durability, and
            custom-fit solutions. Whether you need standard bolts or specialized
            screws, we provide quality fasteners in multiple grades and
            finishes.
          </p>

          <ul className="list-disc list-inside text-gray-700">
            <li>
              <strong>Materials:</strong> SS 304, SS 202, Mild Steel{" "}
              <strong>(Grade 4.6)</strong>, High Tensile{" "}
              <strong>(Grades 8.8 & 10.9)</strong>
            </li>
            <li>
              <strong>Types:</strong> Hex Bolts/Screw, Socket Head Cap Screw,
              Screws, Washers, Nuts, Threaded Rods, Anchors
            </li>
            <li>
              <strong>Coating Options:</strong> Electroplating, Galvanized, Zinc
              Coated, Blackened
            </li>
            <li>
              <strong>Sizes:</strong> M4 to M56 and custom lengths on demand
            </li>
          </ul>
        </div>

        {/* USP Fastener Supply Process - Carousel */}
        <div className="bg-white p-6 rounded shadow space-y-6">
          <h2 className="text-2xl font-bold mb-4 text-center">
            Our USP – Customised Fastener Packaging
          </h2>
          <p className="text-gray-700 text-base text-center mb-6">
            We follow a robust 5-step packaging and supply process to ensure
            corrosion resistance, weather protection, and easy on-site
            installation for all our fasteners. Explore the step-by-step process
            below:
          </p>
          <div className="w-full flex justify-center">
            <div className="relative w-full max-w-3xl">
              <Slider {...sliderSettings}>
                {uspSlides.map((img, idx) => (
                  <div
                    key={idx}
                    className="flex flex-col items-center justify-center min-h-[22rem] bg-gray-100 border border-gray-200 rounded-lg p-6 shadow-lg"
                  >
                    <div className="flex justify-center w-full">
                      <img
                        src={img.src}
                        alt={img.caption}
                        className="w-full max-w-xs sm:max-w-sm md:max-w-md h-48 sm:h-60 md:h-72 object-contain rounded-lg shadow-lg mb-4 mx-auto"
                      />
                    </div>
                    <div className="text-center text-gray-700 text-lg font-bold mb-1">
                      Step {idx + 1}
                    </div>
                    <div className="text-center text-gray-700 text-base font-medium">
                      {img.caption}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>

        {/* Image Grid */}
        <div>
          <h3 className="text-2xl font-bold mb-4">Gallery</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {[
              {
                src: "/assets/images/fasteners/bolts.jpg",
                desc: "Hex & Allen Bolts",
              },
              {
                src: "/assets/images/fasteners/washers.jpg",
                desc: "Washers",
              },
              {
                src: "/assets/images/fasteners/packaging.jpg",
                desc: "Moisture-resistant Packaging",
              },
              {
                src: "/assets/images/fasteners/plating.jpg",
                desc: "Electroplated & Coated Fasteners",
              },
              {
                src: "/assets/images/fasteners/anchor.jpg",
                desc: "Anchors",
              },
              {
                src: "/assets/images/fasteners/nuts.jpg",
                desc: "Nuts",
              },
            ].map((img, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded shadow bg-white flex flex-col"
              >
                <img
                  src={img.src}
                  alt={img.desc}
                  className="w-full h-60 object-cover hover:scale-105 transition duration-300"
                />
                <div className="p-3 text-center text-gray-700 text-base font-medium border-t">
                  {img.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-10">
          <a
            href="/Avon_Tools_Brochure.pdf"
            className="inline-block bg-navy hover:bg-navy-dark text-white px-6 py-3 rounded text-lg"
            target="_blank"
            rel="noopener noreferrer"
          >
            📄 Download Detailed Fastener Brochure
          </a>
        </div>
      </div>
    </section>
  );
};

export default Fasteners;
